import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
      <p>В комплекте мужская и женская футболки. Ткань – 100% хлопок высокой плотности.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: [
      {
        title: `Мужской размер`,
        table: size[`paired_tee`].man,
        sizeInfo: `paired_tee`
      },
      {
        title: `Женский размер`,
        table: size[`paired_tee`].woman,
        sizeInfo: `paired_tee`
      }
    ]
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
